<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js'
import { get } from "lodash";

export default {
  mixins: [fandomBasicMixin],
  data: function() {
    return {
      globalState: globalState,
      isContentAvailable: Boolean
    };
  },
  mounted() {
    this.registerAnimation();

    if (this.content.video) {
      $(this.$el).on("inview", (event, isInView) => {
        const video = $(this.$refs.video)[0];
        video.muted = true;
        if (isInView) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
  },
  methods: {
    getContentResponsiveImageURL: Fandom.getContentResponsiveImageURL,
    getContentResponsiveImage: Fandom.getContentResponsiveImage, // used by video
    exists: Fandom.exists,
    scrollToBottom: Fandom.scrollToBottom,
    mayToggleYoutubePopup() {
      if (this.content.play) {
        Vue.set(globalState, "videoPopupContent", { content: this.content, containerContent: this.containerContent });
      }
    }
  },
  computed: {
    videoClasses() {
      // Options: "video-unmask", "video-16by9" and "video-flat"
      if (this.content.video_mode != "video-unmask") {
        return "video-16by9";
      } else {
        return this.content.video_mode; // "video-unmask"
      }
    },
    isYoutubePresent() {
      const mediaType = get(this.content, ["play", "media_type"], false);
      return mediaType == "youtube";
    },
    nextArrowPresent() {
      return !this.content.hide_next_arrow;
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="[contentType, { 'inset': content.boxed }]" :id="`media-stripe-${containerContent.name}-${content.$id}`" class="inview_animate" v-if="isContentVisibleToUser()" video-content-component :style="{'background-color': content.background_color}">
    <div @click="mayToggleYoutubePopup()" class="video-content-cover" :class="{'cursor-pointer': isYoutubePresent}">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 p-0">
            <div class="overflow-hidden position-relative" :class="{'max-100vh': this.content.video_mode != 'video-flat'}">
              <div class="ar-16by9">
                <div 
                  v-if="content.image" 
                  class="position-absolute-center w-100 h-100 bg-cover-center" 
                  :class="{ 'inview_animate_zoom': !exists(content.image_zoom) || content.image_zoom == true }" 
                  :style="{'background-image': getContentResponsiveImageURL('image')}"
                ></div>
                <div v-if="content.video" class="position-absolute-center text-center" :class="videoClasses">
                  <video loop webkit-playsinline playsinline ref="video">
                    <source :src="getContentResponsiveImage('video')" type="video/mp4">
                  </video>
                </div>

                <div class="position-absolute-center d-flex flex-column align-items-center justify-content-center">
                  <img v-if="content.icon" :src="expandUrl(content.icon.url)" class="mb-4 header-icon" />
                  <component v-if="content.title && !content.icon" class="h1" :is="content.title_tag || 'h2'">{{content.title}}</component>
                  <component v-if="content.description" :is="content.description_tag || 'p'" v-html="content.description"></component>
                  <div v-if="isYoutubePresent" class="video-content-play-icon"><i class="fal fa-play-circle text-white"></i></div>
                  <p v-if="isYoutubePresent" class="watch-more">{{ft("globals.watch_video")}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[video-content-component] {
  color: $white;

  .video-unmask video {
    position: relative;
    width: 100vw;
    height: calc((9 / 16) * 100vw);
  }

  @media (min-aspect-ratio: 16/9) {
    .video-unmask video {
      height: calc(100vh - #{$header-height-sm});
      width: calc((16 / 9) * calc(100vh - #{$header-height-sm}));
    }
  }

  .far {
    font-size: 3.25rem;
  }

  .video-content-play-icon {
    font-size: 5rem;
    color: $primary;
  }

  .watch-more {
    font-weight: 600;
    font-size: 1.125rem;
    text-transform: uppercase;
  }

  .max-100vh {
    max-height: calc(100vh - #{$header-height-sm});
  }

  .header-icon {
    width: 15rem;
    max-width: 50%;
  }

  .icon-down {
    position: absolute;
    bottom: 1rem;
    color: $white;
    font-size: 1.5rem;
  }

  @include media-breakpoint-up(lg) {
    &.inset {
      padding: 5rem;
    }
  }

}
</style>